import {createAction, props} from '@ngrx/store';

export const slideChanged = createAction(
  '[Slider Component] Slide changed',
  props<{ payload: { slideId: number } }>()
);
